import React from 'react'

const Contact = () => {
    return (
        <div className="contact-us container">
            <h1 className="h1">Contact</h1>
        </div>
    )
}

export default Contact
